<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Design Tips</h1>
      <div class="text-large">Show off your creative side with these great design tips.</div>
    </div>
  </div>
<Posts Category="design-tips" ShowTitle="false" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Posts from "@/components/PostCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Posts
  }
};
</script>
